import { Dialog, Transition } from '@headlessui/react'
import React, { Fragment } from 'react'
import { InfoIcon2 } from '../../Assets/AllSvg'
import { HiChevronUpDown } from 'react-icons/hi2'
import { Tooltip } from '@material-tailwind/react'

const AddTaxRateModal = ({ addTaxRate, setAddTaxRate }) => {
    return (
        <div>
            <Transition.Root show={addTaxRate} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={setAddTaxRate}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-[#c1c9d2b3]" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-10 overflow-y-auto">
                        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md">
                                    <div>
                                        <div className="font-semibold p-[16px_20px] border-b-[1px] border-[#ebeef1] text-base text-gray-900">Add tax rate</div>
                                        <div className="p-[24px_20px] border-b-[1px] border-[#ebeef1]">
                                            <div>
                                                <div className='flex gap-2 items-center'>
                                                    <span className='text-sm text-[#414552] font-medium'>Type</span>
                                                    <Tooltip placement="right" className="bg-white shadow-[0px_0px_10px_1px_rgba(0,0,0,0.15)] text-sm text-start p-[16px] w-full max-w-[300px]" content={
                                                        <div className='text-sm text-[#414552]'>
                                                            The display name of the tax rate ad it will appear to your customer on their receipt email, PDF, hosted invoice page, and Checkout Sessions.
                                                        </div>
                                                    }>
                                                        <button><InfoIcon2 /></button>
                                                    </Tooltip>
                                                </div>
                                                <div className="relative mt-2 max-w-[200px] w-full">
                                                    <select className="input_focus_shadow text-[#404452] font-semibold px-3 w-full bg-white rounded-[6px] focus:outline-none h-[28px] text-[14px] appearance-none">
                                                        <option value="Sales tax">Sales tax</option>
                                                        <option value="VAT">VAT</option>
                                                        <option value="GST">GST</option>
                                                        <option value="">Custom</option>
                                                    </select>
                                                    <HiChevronUpDown className="absolute top-[2px] text-gray-800 right-0 flex items-center pr-1 text-[25px]" />
                                                </div>
                                            </div>
                                            <div className='mt-8'>
                                                <div className='flex gap-2 items-center'>
                                                    <span className='text-sm text-[#414552] font-medium'>Description</span>
                                                    <Tooltip placement="right" className="bg-white shadow-[0px_0px_10px_1px_rgba(0,0,0,0.15)] text-sm text-start p-[16px] w-full max-w-[300px]" content={
                                                        <div className='text-sm text-[#414552]'>
                                                            The description is for internal use only and will not visible to your customers.
                                                        </div>
                                                    }>
                                                        <button><InfoIcon2 /></button>
                                                    </Tooltip>
                                                </div>
                                                <div className="relative mt-2 w-full">
                                                    <input type='text' className="input_focus_shadow text-[#404452] font-semibold px-3 w-full bg-white rounded-[6px] focus:outline-none h-[28px] text-[14px] appearance-none" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="font-semibold p-[16px_20px] flex justify-end text-base text-gray-900 gap-2">
                                            <button onClick={() => setAddTaxRate(false)} className="h-[30px] rounded-[6px] input_focus_shadow text-[14px] font-semibold p-[0_8px]">Cancel</button>
                                            <button className="h-[30px] rounded-[6px] text-white bg-[#625afa] text-[14px] font-semibold p-[0_8px]">Add tax rate</button>
                                        </div>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </div>
    )
}

export default AddTaxRateModal